<template>
  <v-card class="d-block rounded pt-4 px-4">
    <div class="text-h6 accent--text mb-2">
      Brand
      <span v-if="rules.brand_input" class="red--text">* </span>
    </div>
    <div v-if="!isCreateRequest">
      <BrandInput
        v-model="globalBrand"
        :rules="rules.brand_input ? rules.brand_input : []"
      ></BrandInput>
    </div>
    <div v-else>
      <v-autocomplete
        v-model="brandName"
        return-object
        clearable
        outlined
        item-text="name"
        label="Brand"
        :items="$store.state.brands"
        :disabled="isCreateRequest"
      ></v-autocomplete>
    </div>

    <v-autocomplete
      return-object
      v-model="selected.translation"
      clearable
      filled
      hide-details
      item-value="code"
      item-text="reference"
      :items="items.translations"
      label="Search for a language..."
      prepend-inner-icon="mdi-magnify"
    ></v-autocomplete>
    <v-tabs v-model="tab" class="mt-3">
      <v-tab
        v-for="(l, i) in filteredLocales"
        :key="i"
        :href="`#tab-${l.code}`"
      >
        <!-- <v-badge
          v-if="!readOnly"
          mode="in-out"
          :value="!l.data.name && !l.data.description"
          color="pink"
          icon="mdi-tooltip-edit"
        >
          {{ l.name }}
        </v-badge> -->

        <v-badge
          v-if="
            (differences &&
              differences.locales &&
              differences.locales[l.code] &&
              differences.locales[l.code].name) ||
              (differences &&
                differences.locales &&
                differences.locales[l.code] &&
                differences.locales[l.code].description)
          "
          mode="in-out"
          color="pink"
          icon="mdi-pencil"
        >
          {{ l.name }}
        </v-badge>
        <v-badge
          v-else
          :value="!l.data.name && !l.data.description"
          color="pink"
          dot
        >
          {{ l.name }}
        </v-badge>
      </v-tab>
    </v-tabs>
    <div class="mt-5 ">
      <v-tabs-items v-model="tab">
        <v-tab-item
          :value="`tab-${o.code}`"
          v-for="(o, i) in filteredLocales"
          :key="i"
        >
          <div class="text-h6 accent--text">
            Product name
            <span
              v-if="
                rules.locales &&
                  rules.locales[o.code] &&
                  rules.locales[o.code].name
              "
              class="red--text"
              >*
            </span>
          </div>
          <v-badge
            v-if="
              differences &&
                differences.locales &&
                differences.locales[o.code] &&
                differences.locales[o.code].name
            "
            color="pink"
            icon="mdi-pencil"
            class="d-flex justify-end mr-4"
          ></v-badge>
          <v-text-field
            :rules="
              rules.locales && rules.locales[o.code] && rules.locales[o.code].name ? rules.locales[o.code].name : []
            "
            v-if="isForm"
            :disabled="readOnly"
            outlined
            class="mt-3"
            placeholder="Product name here..."
            v-model="o.data.name"
          />
          <div v-else class="py-3">
            <span
              v-if="valueRef"
              v-html="
                difference(
                  valueRef.find(v => v.code === o.code).data.name,
                  o.data.name
                )
              "
            ></span>
            <span v-else>{{ o.data.name }}</span>
          </div>
          <div class="text-h6 accent--text mb-3">
            Description
            <span
              v-if="
                rules.locales &&
                  rules.locales[o.code] &&
                  rules.locales[o.code].description
              "
              class="red--text"
              >*
            </span>
          </div>
          <v-badge
            v-if="
              differences &&
                differences.locales &&
                differences.locales[o.code] &&
                differences.locales[o.code].description
            "
            color="pink"
            icon="mdi-pencil"
            class="d-flex justify-end  mr-4"
          >
          </v-badge>
          <v-textarea
            :rules="
              rules.locales &&
                rules.locales[o.code] &&
                rules.locales[o.code].description ? rules.locales[o.code].description : []
            "
            v-if="isForm"
            :disabled="readOnly"
            outlined
            no-resize
            class="mt-3"
            v-model="o.data.description"
            placeholder="Enter description here..."
          />
          <div v-else class="py-3">
            <span
              v-if="valueRef"
              v-html="
                difference(
                  valueRef.find(v => v.code === o.code).data.description,
                  o.data.description
                )
              "
            ></span>
            <span v-else>{{ o.data.description }}</span>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <EmptyListPlaceholder
      :height="250"
      v-if="filteredLocales <= 0"
      :is-loading="false"
      message="You don't have this language in the list"
      :message-size="17"
      :icon="'mdi-translate'"
      :icon-size="40"
    >
      <v-btn
        class="mt-2"
        text
        color="primary"
        @click="addLocale(selected.translation)"
        v-if="!readOnly"
      >
        <v-icon left>mdi-plus</v-icon>
        Add this language (translation)</v-btn
      >
    </EmptyListPlaceholder>
  </v-card>
</template>

<script>
import * as Diff from "text-diff"
import EmptyListPlaceholder from "@/components/base/EmptyListPlaceholder"
import { TRANSLATIONS } from "@/data"
import { capitalize, cloneDeep, sortBy } from "lodash"
import { required } from "@/utils/validator"
import BrandInput from "@/components/inputs/BrandInput.vue"
import _ from "lodash"
import { ProductService } from "@/services"

export default {
  components: {
    EmptyListPlaceholder,
    BrandInput
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    tabIndex: {
      type: String,
      default: "tab-en"
    },
    valueRef: {
      type: Array,
      default: null
    },
    value: {
      type: Array,
      default: null
    },
    isForm: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    differences: {
      type: Object,
      default: () => ({})
    },
    isCreateRequest: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tab: 1,
      brandName: "",
      localesValue: [],
      selected: {
        translation: null
      },
      items: {
        translations: TRANSLATIONS.map(t => ({
          ...t,
          reference: capitalize(t.reference.replace("_", ""))
        }))
      }
    }
  },
  methods: {
    required,
    difference(o, n) {
      const d = new Diff()
      let diff = d.main(o, n)
      d.cleanupSemantic(diff)
      return d.prettyHtml(diff)
    },
    addLocale(locale) {
      const loc = {
        code: locale.code.toLowerCase(),
        name: locale.reference,
        data: {
          name: "",
          description: ""
        }
      }
      this.localesValue.push(loc)
      this.selected.translation = null
      this.$emit("addLocale", cloneDeep(loc))
    },

    getBrandName() {
      ProductService.get(this, this.$route.params.product).then(result => {
        this.brandName = result.brand_name
      })
    }
  },
  mounted() {
    this.getBrandName()
  },
  watch: {
    localesValue(newValue, oldValue) {
      if (newValue !== null && !this.readOnly) {
        this.$emit("input", newValue)
      }
    },
    value: {
      deep: true,
      handler(newValue, oldValue) {
        this.localesValue = newValue
      }
    },
    tabIndex(newValue, oldValue) {
      this.tab = newValue
    },
    tab(newValue, oldValue) {
      this.$emit("onTabChange", newValue)
    }
  },
  created() {
    this.localesValue = this.lo.cloneDeep(this.value)
  },
  computed: {
    filteredLocales() {
      let locales = (this.localesValue || []).filter(curr =>
        this.selected.translation
          ? [this.selected.translation.code.toLowerCase()].includes(
              curr.code.toLowerCase()
            )
          : true
      )

      return sortBy(locales, ({ code }) =>
        ["en", "fr", "es"].includes(code) ? 0 : 1
      )
    },

    globalBrand: {
      get() {
        return this.$store.state.globalBrand
      },
      set(v) {
        this.$store.commit("setGlobalBrand", v)
      }
    }
  }
}
</script>

<style lang="scss">
del {
  background: #ff9d9d;
  text-decoration: auto;
}
ins {
  background: #9cff9c;
  text-decoration: auto;
}
</style>
